import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDriving(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#driving_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#driving_svg__b)" strokeWidth={20} />
      </g>
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.667}
        d="m72.11 57.988 4.676-7.386a4.9 4.9 0 0 1 4.146-2.269h14.136c1.686 0 3.252.858 4.146 2.27l4.675 7.385m-31.778 0h-2.445m2.445 0V68.85c0 1.556 1.277 2.817 2.852 2.817s2.852-1.261 2.852-2.817v-.517h20.37v.517c0 1.556 1.277 2.817 2.852 2.817s2.852-1.261 2.852-2.817V57.988m0 0h2.444m-28.518 3.679h3.259m13.852 0h3.259"
      />
      <defs>
        <linearGradient
          id="driving_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="driving_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDriving);
export default ForwardRef;
